import React from "react";
import { PurchaseButton } from "./PurchaseButton";
export function ClosingSection() {
  return <section className="bg-blush-light" data-id="element-25" data-mp="otm22ypj9ua5">
      <div className="mx-auto max-w-3xl px-5 py-20 text-center md:py-28" data-id="element-26" data-mp="oux2qpnomlx1">
        <h2 className="font-display text-3xl font-semibold leading-tight text-ink md:text-5xl md:leading-[1.1]" data-id="element-27" data-mp="12twtq3yo3cwd">
          La foi se transmet aussi dans les petits moments partagés.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-ink-soft md:text-xl" data-id="element-28" data-mp="1cpzsr0y82vf3">
          Une histoire avant de dormir. Une question posée avec tendresse. Une
          activité réalisée ensemble. Parfois, ce sont ces petits instants qui
          laissent les plus beaux souvenirs dans le cœur d’un enfant.
        </p>
        <p className="mt-8 font-display text-xl font-semibold italic text-terracotta-dark md:text-2xl" data-id="element-29" data-mp="1hi9qh35kwzrx">
          Commencez à créer ces moments avec votre Méga Pack de Paraboles
          Chrétiennes.
        </p>
        <div className="mx-auto mt-10 max-w-md" data-id="element-30" data-mp="1qk96bs4uxxta">
          <PurchaseButton label="Je découvre le Méga Pack" data-id="element-31" data-mp="22cvuckdmmfmy" />
        </div>
      </div>
    </section>;
}